module.exports = __webpack_public_path__ + "media/images/features/4/location-2-305a4b5155d4acff55335b1c2d1d3a30.jpg";